import React from 'react';
import { recipesData } from '../../../data/regionalChef/recipesData';

const KnowledgeBase = ({ onBack }) => {
  const allRecipes = Object.values(recipesData);

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '40px 20px', fontFamily: 'sans-serif', paddingBottom: '80px' }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h2 style={{ color: '#ff4757', margin: '0 0 10px 0', fontSize: '28px' }}>📚 สารานุกรมอาหาร 4 ภาค</h2>
        <p style={{ color: '#57606f', margin: 0 }}>ศึกษาเกร็ดความรู้และ <strong>สูตรการคราฟต์</strong> ก่อนลงมือทำจริง</p>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {allRecipes.map((recipe, index) => (
          <div key={recipe.id} style={{ backgroundColor: '#ffffff', border: '1px solid #dfe4ea', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.02)' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
              <h3 style={{ margin: 0, color: '#2f3542', fontSize: '20px' }}>{index + 1}. {recipe.name}</h3>
              <span style={{ backgroundColor: '#ffefcd', color: '#e58e26', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
                ฿{recipe.basePrice}
              </span>
            </div>

            {/* ส่วนแสดงสูตรอาหาร (Steps) */}
            <div style={{ backgroundColor: '#f1f2f6', padding: '12px', borderRadius: '8px', marginBottom: '15px' }}>
              <h4 style={{ margin: '0 0 8px 0', color: '#3742fa', fontSize: '14px' }}>🍳 สูตรการทำ:</h4>
              <ul style={{ margin: 0, paddingLeft: '20px', color: '#2f3542', fontSize: '14px', lineHeight: '1.6' }}>
                {recipe.steps.map((step, idx) => (
                  <li key={idx}>{step}</li>
                ))}
              </ul>
            </div>
            
            {/* ส่วนแสดงความรู้ (Knowledge) */}
            <div style={{ borderLeft: '4px solid #2ed573', paddingLeft: '12px', fontSize: '14px', lineHeight: '1.6', color: '#57606f' }}>
              <strong>เกร็ดประวัติศาสตร์:</strong> {recipe.knowledge}
            </div>
            
          </div>
        ))}
      </div>

      <div style={{ position: 'fixed', bottom: '20px', left: '0', right: '0', textAlign: 'center', zIndex: 10 }}>
        <button 
          onClick={onBack}
          style={{ padding: '12px 40px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#2f3542', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}
        >
          กลับสู่หน้าหลัก
        </button>
      </div>
    </div>
  );
};

export default KnowledgeBase;